<template>
  <el-container class="cx-content">
    <el-header ref="topheader" class="cx-header"  height="50px">
      <navbar></navbar>
    </el-header>
    <el-container class="cx-content">
      <!-- 左侧导航栏 -->
      <el-aside style="width:192px;">
        <sidebar class="sidebar-left-content"></sidebar>
      </el-aside>
      <el-main class="cx-main">
        <!-- 主体视图层 -->
        <transition name="fade-transverse">
          <router-view class="cx-view" v-if="$route.meta.noCache && isRouterAlive" />
        </transition>
        <transition name="fade-transverse">
          <keep-alive>
            <router-view class="cx-view" v-if="!$route.meta.noCache" />
          </keep-alive>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { Sidebar, Navbar } from './components'
export default {
  components: { Sidebar, Navbar },
  provide() {
    return {
      reload: this.reload
    }
  },
  name: 'index',
  data() {
    return {
      // 刷新token锁
      refreshLock: false,
      // 刷新token的时间
      refreshTime: '',
      isRouterAlive: true
    }
  },
  computed: { ...mapGetters(['isLock']) },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.cx-header {
  padding: 0;
  height: 50px;
}
.cx-content {
  height: 100%;
}
.cx-main {
  position: relative;
  padding: 0;
  background-color: #eee;
}
.cx-view {
  width: calc(100% - 16px);
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100% - 16px);
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue